import * as React from "react";
import { useNotify, useRedirect } from "react-admin";
import Create from "../../baseComponents/Create";

import { FormCalorieCoefficient } from "./FormCalorieCoefficient";



export const CalorieCoefficientCreate = (props) => {
  const { callback } = props;
  const redirect = useRedirect();
  const notify = useNotify();
  const onSuccess = (data) => {
    if (callback) {
      callback(data);
    } else {
      notify('ra.notification.created');
      redirect("list", "calorieCoefficients", data.id, data);
    }
  };
  return (
    <Create mutationOptions={{ onSuccess }} >
      <FormCalorieCoefficient></FormCalorieCoefficient>
    </Create>
  );
};
